window.DomWeakMap = new WeakMap();

/* eslint-enable */
export const scrollToElement = (element, offset = 0) => {
    let params;
    let scrollPos;
    if (element) {
        params = element.getBoundingClientRect();
        scrollPos = window.scrollY;
        window.scrollTo({
            top: params.top + scrollPos + offset,
            behavior: 'smooth',
        });
    } else {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }
};

/* eslint-disable consistent-return */
export const DomWeakMapUtil = (elementObject, key, value) => {
    if (elementObject.nodeType !== 1 && elementObject.nodeType !== 9) {
        console.error('Cannot set weakmap on given element node');
    } else {
        if (!window.DomWeakMap.has(elementObject)) {
            window.DomWeakMap.set(elementObject, { store: {} });
        }

        if (window.DomWeakMap.has(elementObject)) {
            if (value) {
                const tempObj = {
                    ...window.DomWeakMap.get(elementObject).store,
                    ...{ [key]: value },
                };

                window.DomWeakMap.set(elementObject, { store: tempObj });
            } else {
                return window.DomWeakMap.get(elementObject).store[key];
            }
        }
    }
};

export const getProductDivision = () => {
    const productDivision = document.querySelector('body').dataset.productDivision || null;
    return productDivision;
};

export const debounce = (f, delay) => {
    let timer = 0;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => f.apply(this, args), delay);
    };
};

export const elementResize = (element, callback, delay) => {
    const elementObserver = new ResizeObserver(debounce(() => {
        callback();
    }), delay);

    elementObserver.observe(element);
};
